import { useState, useEffect } from 'react';
import { Layout } from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../lib/supabase';

function initials(name) {
  if (!name) return '?';
  return name.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2);
}

export function AthleteSettings() {
  const { profile } = useAuth();
  const id = profile?.id;

  const [avatarUrl, setAvatarUrl] = useState(null);
  const [avatarUploading, setAvatarUploading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    supabase
      .from('athlete_profiles')
      .select('avatar_url')
      .eq('id', id)
      .maybeSingle()
      .then(({ data }) => {
        if (data?.avatar_url) setAvatarUrl(data.avatar_url);
        setLoading(false);
      });
  }, [id]);

  async function handleAvatarUpload(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setAvatarUploading(true);
    const ext = file.name.split('.').pop();
    const path = `${id}.${ext}`;
    const { error: upErr } = await supabase.storage.from('avatars').upload(path, file, { upsert: true });
    if (upErr) {
      console.error('[avatar upload] storage error:', upErr.message);
      setAvatarUploading(false);
      return;
    }
    const { data: urlData } = supabase.storage.from('avatars').getPublicUrl(path);
    const url = `${urlData.publicUrl}?t=${Date.now()}`;
    await supabase.from('athlete_profiles').upsert({ id, avatar_url: url });
    setAvatarUrl(url);
    setAvatarUploading(false);
  }

  if (loading) {
    return (
      <Layout>
        <div className="loading-screen" style={{ minHeight: 200 }}>
          <div className="loading-dot-row">
            <div className="loading-dot" /><div className="loading-dot" /><div className="loading-dot" />
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div style={{ marginBottom: 24 }}>
        <p className="page-eyebrow">Settings</p>
        <h1 className="page-title">My Profile</h1>
        <p style={{ margin: '4px 0 0', fontSize: 14, color: 'var(--gray-400)' }}>
          Manage your athlete profile
        </p>
      </div>

      <div className="section-card" style={{ maxWidth: 560 }}>
        <div className="section-card-header">
          <span className="section-card-title">Profile Photo</span>
        </div>
        <div style={{ padding: '24px 28px', display: 'flex', alignItems: 'center', gap: 20 }}>
          <label style={{ cursor: 'pointer', flexShrink: 0 }} title="Click to upload photo">
            <input
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleAvatarUpload}
              disabled={avatarUploading}
            />
            <div className="profile-avatar" style={{ width: 80, height: 80, fontSize: 24 }}>
              {avatarUrl
                ? <img src={avatarUrl} alt={profile?.full_name} />
                : initials(profile?.full_name)
              }
              <div className="profile-avatar-overlay">
                {avatarUploading ? '\u2026' : 'Upload'}
              </div>
            </div>
          </label>
          <div>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: 'var(--navy)' }}>
              {avatarUploading ? 'Uploading\u2026' : avatarUrl ? 'Change Photo' : 'Upload Photo'}
            </p>
            <p style={{ margin: '4px 0 12px', fontSize: 13, color: 'var(--gray-400)' }}>
              Your photo will appear in the nav bar and your coach will see it on your athlete page.
            </p>
            <label style={{ display: 'inline-block', cursor: 'pointer' }}>
              <input
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleAvatarUpload}
                disabled={avatarUploading}
              />
              <span
                className="btn btn-primary"
                style={{ fontSize: 13, padding: '8px 18px', width: 'auto', display: 'inline-block' }}
              >
                {avatarUploading ? 'Uploading\u2026' : avatarUrl ? 'Change Photo' : 'Upload Photo'}
              </span>
            </label>
          </div>
        </div>
      </div>
    </Layout>
  );
}
